export enum LegacyStatusCodes {
  Incomplete = -4,
  Processing = -3,
  Correcting = -2,
  Rejected = -1,
  Pending = 0,
  Approved = 1
}
